import React from "react";
import { LANDING_URL, SUPPORT_EMAIL } from "./constants";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-links">
        <a
          href={`${LANDING_URL}/#features`}
          target="_blank"
          rel="noreferrer"
          className="footer-link"
        >
          Features
        </a>
        <a
          href={`${LANDING_URL}/#how-it-works`}
          target="_blank"
          rel="noreferrer"
          className="footer-link"
        >
          How it works
        </a>
        <a
          href={`${LANDING_URL}/#pricing`}
          target="_blank"
          rel="noreferrer"
          className="footer-link"
        >
          Pricing
        </a>
        <a href={`mailto:${SUPPORT_EMAIL}`} className="footer-link">
          Contact us
        </a>
      </div>
    </footer>
  );
};

export default Footer;
